import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { getTimeLeft, ProblemModel } from 'src/app/store/problem/model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-problem-preview',
  templateUrl: './problem-preview.component.html',
  styleUrls: ['./problem-preview.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class ProblemPreviewComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private problemFacade = inject(ProblemFacade);
  translate = inject(TranslateService);
  private titleService = inject(Title);

  problem: ProblemModel;

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MESSAGE_PAGE').subscribe(page => {
      this.translate.get('TITLE_MAIN').subscribe(main => {
        this.titleService.setTitle(page + ' ' + main);
      });
    });

    this.route.params.subscribe(params => {
      this.problemFacade.getById(+params['id']).subscribe(problem => {
        this.problem = problem;
      });
    });
  }

  getTimeLeft() {
    return getTimeLeft(this.problem);
  }

  convertImage(problem: ProblemModel): any {
    return this.problemFacade.convertImage(problem);
  }
}
